var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFutures = function SvgFutures(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    fillRule: "evenodd",
    d: "M17.306 4.253H12.01A2.796 2.796 0 0 0 9.213 7.05v11.532c0 .157.127.284.284.284h7.81a2.796 2.796 0 0 0 2.795-2.796V7.05a2.796 2.796 0 0 0-2.796-2.796M12.01 2.56a4.49 4.49 0 0 0-4.49 4.49v2.747H5.196a2.993 2.993 0 0 0-2.993 2.994v4.277a3.49 3.49 0 0 0 3.239 3.483v.01h3.896v-.007q.078.006.158.006h7.81a4.49 4.49 0 0 0 4.489-4.49V7.05a4.49 4.49 0 0 0-4.49-4.49zm-6.812 8.932h2.321v7.09a.284.284 0 0 1-.284.284H5.696a1.8 1.8 0 0 1-1.798-1.798V12.79a1.3 1.3 0 0 1 1.3-1.3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC5D",
    fillRule: "evenodd",
    d: "M17.444 7.957c0-.33-.27-.6-.6-.6h-3.78c-.33 0-.6.27-.6.6s.27.6.6.6h2.31l-3.72 3.33c-.24.22-.26.6-.04.84s.6.26.84.04l3.8-3.42v2.55c0 .33.27.6.6.6s.6-.27.6-.6v-3.94z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC5D",
    d: "M11.75 15.143a.75.75 0 0 0 0 1.5h5.415a.75.75 0 1 0 0-1.5z"
  })));
};
export default SvgFutures;